import styled from "styled-components";

export const LessonHtmlContentContainer = styled.div`
  color: ${({ theme }) => theme?.classwork?.imersive?.tagTextColor};
  margin-top: 1rem;
  ul,
  ol {
    margin-left: 1rem;
  }
  .lesson-html-content {
    display: block;
    width: 100%;
    height: 100%;
    iframe {
      width: 100%;
      height: 100%;
      aspect-ratio: 16 / 9;
    }
    table,
    img {
      width: 100% !important;
    }
    img {
      border-radius: 8px;
    }
  }
`;
